import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import history from '../../history';
import Step from '../SurveyStep';
import SurveyHeader from '../SurveyHeader';
import SurveyFooter from '../SurveyFooter';
import Flexbox from 'flexbox-react';

class Survey extends PureComponent{
	render() {
		const { currentStep } = this.props;
		return (
			<Flexbox flexDirection="column">
				<SurveyHeader/>
				<TransitionGroup className="Steps">
					<CSSTransition
						appear={true}
						onExited={() => history.replace(`/survey/${currentStep}`)}
						classNames="StepAnimation"
						key={`card_${currentStep}`}
						timeout={{ enter: 500, exit: 100 }}
					>
						<Step/>
					</CSSTransition>
				</TransitionGroup>
				<SurveyFooter/>
			</Flexbox>
		);
	}
}

const mapStateToProps = ({ survey: { currentStep } }) => {
	return {
		currentStep
	};
};

export default connect(mapStateToProps)(Survey);



// WEBPACK FOOTER //
// ./src/components/SurveyProcess/SurveyProcess.js